import { siteMeta, heroReports } from "@/mocks/maydayContent";

export default function Hero() {
  return (
    <section id="home" className="relative w-full overflow-hidden">
      <div className="mx-auto grid w-full max-w-[1200px] gap-8 px-4 md:px-6 py-10 lg:grid-cols-12 lg:gap-10 lg:py-14">
        {/* intro */}
        <div className="lg:col-span-5 flex flex-col justify-center">
          <div className="mb-4 flex items-center gap-2">
            <span className="rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">劳动节特辑</span>
            <span className="rounded-full bg-background-200/70 px-3 py-1 text-xs text-foreground-500">持续追踪</span>
          </div>
          <h1 className="font-heading text-4xl font-black leading-tight text-foreground-950 md:text-5xl lg:text-[54px] lg:leading-[1.12]">
            劳动节背后，
            <br />
            那些<span className="text-primary-600">不为人知</span>的真相
          </h1>
          <p className="mt-5 max-w-md text-base leading-relaxed text-foreground-600">
            {siteMeta.slogan}。我们持续追踪假期安排、调休争议、节日消费与出游乱象，用调查与数据为你拨开层层迷雾，让每一次长假都过得明白。
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <a
              href="#topic"
              className="inline-flex items-center whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors"
            >
              查看核心专题
              <i className="ri-arrow-down-line ml-1.5 text-sm w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a
              href="#diaoxiu"
              className="inline-flex items-center whitespace-nowrap rounded-md bg-background-200/70 px-5 py-3 text-sm font-medium text-foreground-800 hover:bg-background-200 transition-colors"
            >
              调休争议真相
              <i className="ri-arrow-right-line ml-1.5 text-sm w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>

        {/* featured reports */}
        <div className="lg:col-span-7 grid gap-4 sm:grid-cols-2">
          {heroReports.map((r, i) => (
            <article
              key={r.title}
              className={`group relative flex flex-col overflow-hidden rounded-lg ${i === 0 ? "sm:col-span-2" : ""}`}
            >
              <div className="relative h-56 overflow-hidden rounded-lg sm:h-60">
                <img
                  src={r.image}
                  alt={r.title}
                  className="h-full w-full object-cover"
                  width={1200}
                  height={800}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent"></div>
                <span className="absolute left-3 top-3 rounded bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  {r.tag}
                </span>
                <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                  <h3 className="font-heading text-base font-bold leading-snug text-background-50 md:text-lg">
                    {r.title}
                  </h3>
                </div>
              </div>
              <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-foreground-600">{r.lead}</p>
              <div className="mt-2 flex items-center gap-3 text-xs text-foreground-400">
                <span>{r.date}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  {r.reads}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>

      {/* stats strip */}
      <div id="hot" className="scroll-mt-24 border-y border-background-200/70 bg-background-100/60">
        <div className="mx-auto grid w-full max-w-[1200px] grid-cols-2 gap-px px-4 md:grid-cols-4 md:px-6">
          {[
            { v: "12.6w+", l: "全网热议", i: "ri-fire-line" },
            { v: "120+", l: "深度调查", i: "ri-file-search-line" },
            { v: "30+", l: "避坑指南", i: "ri-shield-check-line" },
            { v: "99%", l: "读者好评", i: "ri-thumb-up-line" },
          ].map((s) => (
            <div key={s.l} className="flex items-center gap-3 py-4">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50 text-primary-600">
                <i className={`${s.i} text-lg w-5 h-5 flex items-center justify-center`}></i>
              </span>
              <div>
                <div className="font-heading text-xl font-bold text-foreground-950">{s.v}</div>
                <div className="text-xs text-foreground-500">{s.l}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}